import * as React from 'react';
import { getWhiteLabelSiteName, getWhiteLabelSiteUrl } from '../../../redux/modules/whiteLabel';
import { FormattedMessage } from 'react-intl';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

const WhiteLabelCrown = () => {
    const siteName = useSelector(getWhiteLabelSiteName);
    const siteUrl = useSelector(getWhiteLabelSiteUrl);
    return (
        <StyledCrown>
            <StyledCrownInner>
                {Boolean(siteUrl) && (
                    <Link secondary to={siteUrl}>
                        <FormattedMessage id="return_to" values={{ name: siteName }} />
                    </Link>
                )}
            </StyledCrownInner>
        </StyledCrown>
    );
};

export default React.memo(WhiteLabelCrown);

const StyledCrown = styled.div`
    background-color: ${({ theme }) => theme.colors.grey300};
    height: 28px;
    text-align: center;
    padding: 0 20px;
`;

const StyledCrownInner = styled.div`
    color: ${({ theme }) => theme.colors.grey100};
    font-size: 12px;
    height: 14px;
    padding-top: 6px;
    max-width: 1200px;
    margin: 0 auto;
    text-align: left;

    & > a {
        &:hover {
            color: ${({ theme }) => theme.colors.grey100};
            text-decoration: underline;
        }
    }
`;
